import React, { useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Form } from 'react-bootstrap';
import { UserData } from '@/portal/types/UserData.ts';
import UserMultiSelect from './UserMultiSelect.tsx';

interface NotificationSettingsData {
  patientReferralEmailUsers: UserData[];
}

export type NotificationSettingsFormData = NotificationSettingsData;

interface NotificationSettingsEditProps {
  data: NotificationSettingsData;
  onSubmit: (formData: NotificationSettingsFormData) => void;
  submitRef: React.RefObject<(() => void) | null>;
}

const NotificationSettingsEdit: React.FC<NotificationSettingsEditProps> = ({
  data,
  onSubmit,
  submitRef,
}) => {
  const { control, getValues } = useForm<NotificationSettingsFormData>({
    defaultValues: {
      patientReferralEmailUsers: data.patientReferralEmailUsers,
    },
  });

  // Expose the submit function to the parent via ref
  useEffect(() => {
    submitRef.current = () => {
      // For notification settings, we always want to submit the full current state
      // rather than just changed fields, since we need to know the complete list
      const currentValues = getValues();
      onSubmit(currentValues);
    };
  }, [getValues, onSubmit, submitRef]);

  return (
    <Form>
      <Form.Group className="mb-3">
        <Controller
          name="patientReferralEmailUsers"
          control={control}
          defaultValue={data.patientReferralEmailUsers}
          render={({ field }) => (
            <UserMultiSelect
              selected={field.value ?? []}
              onChange={field.onChange}
            />
          )}
        />
      </Form.Group>
    </Form>
  );
};

export default NotificationSettingsEdit;
